import Icon from '../components/Icon.vue'

Icon.register({"hashtag":{"width":448,"height":512,"paths":[{"d":"M440.7 182.1L447.8 142.1C449.1 134.8 443.5 128 436 128H361.2L375.8 46.1C377.1 38.8 371.5 32 364 32H323.4A12-12 0 0 1 311.6 41.9L296.2 128H197.5L212.2 46.1C213.5 38.8 207.8 32 200.3 32H159.7A12-12 0 0 1 147.9 41.9L132.5 128H53.4A12-12 0 0 1 41.6 137.9L34.5 177.9C33.2 185.2 38.8 192 46.3 192H121.1L98.2 320H19.1A12-12 0 0 1 7.3 329.9L0.2 369.9C-1.1 377.2 4.5 384 12 384H86.8L72.2 465.9C70.9 473.2 76.5 480 84 480H124.6A12-12 0 0 1 136.4 470.1L151.8 384H250.5L235.8 465.9C234.5 473.2 240.2 480 247.7 480H288.3A12-12 0 0 1 300.1 470.1L315.5 384H394.6A12-12 0 0 1 406.4 374.1L413.5 334.1C414.8 326.8 409.2 320 401.7 320H326.9L349.8 192H428.9A12-12 0 0 1 440.7 182.1zM261.9 320H163.3L186.1 192H284.7L261.9 320z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/hashtag.js
// module id = null
// module chunks = 